import { render, staticRenderFns } from "./create.vue?vue&type=template&id=5e84edbd&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e84edbd')) {
      api.createRecord('5e84edbd', component.options)
    } else {
      api.reload('5e84edbd', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=5e84edbd&", function () {
      api.rerender('5e84edbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/countries/cities/create.vue"
export default component.exports